import React from "react";
import { Navigate } from "react-router-dom";
import { PaymentsList } from "../../../components/Admin/PaymentsList";
import { usePermissions } from "../../../hooks";

export function Payments() {
  const { hasPermission } = usePermissions();

  if (!hasPermission("paymentCategory", "read")) {
    return <Navigate to="/admin" replace />;
  }

  return <PaymentsList />;
}
export default Payments;
